import { getSessionStorageItem, setSessionStorageItem } from 'in-meeting-experience-ui-components/utils/sessionStotage';
export function appendItemToSessionStorageArray(key, value) {
  const savedArray = getSessionStorageItem(key) || [];
  setSessionStorageItem(key, [...savedArray, value]);
}